export const FILTERS_CACHE_KEY = 'boostRetailFilters';
